// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--lAPaj","title":"title--fV95P"};